<canvas
  baseChart
  [data]="pieChartData"
  [options]="pieChartOptions"
  type="pie"
  *ngIf="pieChartData"
  (chartClick)="chartClicked($event)"
>
</canvas>
